import { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useParams } from 'react-router-dom';

import NutritionFactsPanel from 'components/mealDetails/nutritionFacts/NutritionFactsPanel';
import * as ErrorLogging from 'services/ErrorLogging';
import RequestService from 'services/RequestService';

import NutritionalFactsSlideout from './NutritionalFactsSlideout';

const NutritionFactsSkeleton = () => (
  <div className="mx-auto max-w-screen-md">
    <header className="px-6 pb-2 pt-4">
      <Skeleton height={40} width={700} className="mb-4" />
      <Skeleton height={20} width={200} className="mb-4" />
    </header>
    <section className="p-4">
      <div className="flex justify-center">
        <Skeleton height={400} width={400} />
      </div>
    </section>
  </div>
);

const NutritionalFactsContainer = ({ domMealId = null }) => {
  const [showSlideout, setShowSlideout] = useState(false);
  const [meal, setMeal] = useState();
  const { mealId: paramMealId, packingFacility } = useParams();

  const mealId = domMealId || paramMealId;

  const closeSlideout = () => {
    setShowSlideout(false);
  };

  const openSlideout = () => {
    setShowSlideout(true);
  };

  const fetchNutritionalFacts = async () => {
    const response = await RequestService.getNutritionalFacts({
      params: {
        mealId,
        packingFacility,
      },
    });
    if (response.ok) {
      setMeal(response.meal);
    } else {
      if (response.status !== 404) ErrorLogging.captureException(response.error);
      if (packingFacility && mealId) window.location.href = '/';
    }
  };

  useEffect(() => {
    if (mealId) fetchNutritionalFacts();
  }, [mealId, packingFacility]);

  if (packingFacility && mealId) {
    return meal ? (
      <div className="mx-auto max-w-screen-md">
        <NutritionFactsPanel meal={meal} hideIngredientDisclaimer />
      </div>
    ) : (
      <NutritionFactsSkeleton />
    );
  } else {
    return (
      <>
        <button
          onClick={openSlideout}
          className="btn btnTextPrimary w-full p-0.5 text-right bp2:text-left"
        >
          See Full Nutrition Facts
        </button>
        <NutritionalFactsSlideout
          closeSlideout={closeSlideout}
          meal={meal}
          showSlideout={showSlideout}
        />
      </>
    );
  }
};

export default NutritionalFactsContainer;

NutritionalFactsContainer.propTypes = {
  domMealId: PropTypes.string,
};
